<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'current'"
          @itemChange="(e) => (selectedCurrent = e)"
          :label="'Cari'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="salesPersonCode"
          label="Plasiyer"
          filled
          solo
          dense
          :items="salesPersonList"
          :item-text="item => item.name"
          :item-value="item => item.code"
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          :close-on-content-click="false"
          offset-y
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>

import {formattedDate} from "@/momentHelper";
import {mapActions, mapState} from "vuex";
import SearchSelect from "@/components/searchSelect.vue";
/*import {showProcessErrorMessage} from "@/state/alertHelpers";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";*/

export default {
  name: "HedefPotansiyelCari",
  components: {SearchSelect},
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  computed:{
    ...mapState("auth",["user"])
  },
  mounted(){
    this.filterReport()
  },
  data(){
    return {
      currentCode:null,
      dateRangeStart: null,
      dateRangeEnd: null,
      currentSearchText: "",
      currentSearchLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      selectedCurrent: null
    }
  },
  /*validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },*/
  methods:{
    ...mapActions("current", ["fetchCurrentList"]),
    formattedDate,
    /*validationMessages,*/
    async _fetchCurrentList(){
      this.currentSearchResult = await this.fetchCurrentList({
        params:{
          userId : this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2  ? true : false) && {salesPersonCode: this.user.SalesPersonCode },
          ...(this.currentSearchText == "" || this.currentSearchText == null  ? false : true) && {searchText: this.currentSearchText }
        },
        body: {

        },
        loading: false
      });
      this.currentSearchLoading = false;
    },
    filterReport(){
      /*this.$v.$touch();*/
      this.filterRequestObject = {
        StartDate: this.dateRangeStart,
        FinishDate: this.dateRangeEnd,
        CurrentCode: this.selectedCurrent,
      };
      this.$emit("reportFilterChange",this.filterRequestObject);
      /*if(!this.$v.$invalid){

      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })*/

    }
  },
  watch: {
    currentSearchText:function(newVal){
      if(newVal && (newVal.length > 2))
      {
        this.currentSearchResult = [];
        if(this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.currentSearchLoading = true
        this.searchCurrentTimeout = setTimeout(() => {

          this._fetchCurrentList();

        },2000);
      }
    }
  }
}
</script>

<style scoped>

</style>